module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "teacherManager"
  }, [_c('div', {
    staticClass: "breadcrumb",
    staticStyle: {
      "font-size": "14px"
    }
  }, [_vm._v("教师管理")]), _vm._v(" "), _c('div', {
    staticClass: "selectSchool"
  }, [_c('el-select', {
    staticClass: "selectInput",
    attrs: {
      "filterable": "",
      "clearable": "",
      "placeholder": "请输入高校名称",
      "loading": _vm.loading
    },
    on: {
      "change": _vm.getTeachers
    },
    model: {
      value: (_vm.region),
      callback: function($$v) {
        _vm.region = $$v
      },
      expression: "region"
    }
  }, _vm._l((_vm.option), function(item) {
    return _c('el-option', {
      key: item.rootUnid,
      attrs: {
        "label": item.name,
        "value": item.rootUnid
      }
    })
  }), 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "warning",
    staticStyle: {
      "font-size": "14px",
      "margin-left": "15px"
    }
  }, [_vm._v("提示：教师添加成功后，其账号密码默认为123456")]), _vm._v(" "), _c('div', {
    staticClass: "com-list"
  }, [_c('el-table', {
    staticClass: "teacherData",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.teacherData
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "index",
      "prop": "index",
      "label": "序号",
      "width": "80"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "stuId",
      "label": "教职工号",
      "width": "200"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": "姓名",
      "width": "150"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "campusZone",
      "label": "校区",
      "width": "200"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "phone",
      "label": "手机号",
      "width": "200"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "gender",
      "label": "性别"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isimportsuccess),
      expression: "isimportsuccess"
    }],
    staticClass: "warningsuccess",
    staticStyle: {
      "font-size": "14px",
      "margin-left": "15px",
      "color": "red"
    }
  }, [_vm._v("\n\t\t提示：\n\t\t"), _c('br'), _vm._v(" 1,新添加成功老师" + _vm._s(_vm.numSetteacher) + "个\n\t\t"), _c('br'), _vm._v(" 2," + _vm._s(_vm.alreadyteacher) + "已经是老师\n\t")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.wrongData.length > 0),
      expression: "wrongData.length > 0"
    }],
    staticClass: "wrongInfo",
    staticStyle: {
      "font-size": "14px",
      "margin-left": "15px"
    }
  }, [_vm._v("\n\t\t" + _vm._s(_vm.wrongData.length) + "个用户已存在，用户在数据库中的信息如下，以手机号为唯一标识，教工号、姓名或校区冲突认为是冲突\n\t")]), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.wrongData.length > 0),
      expression: "wrongData.length > 0"
    }],
    staticClass: "wrongData",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.wrongData
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "index",
      "prop": "index",
      "label": "序号",
      "width": "80"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "phone",
      "label": "手机号码",
      "width": "150"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": "姓名",
      "width": "120"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "campusZone",
      "label": "校区",
      "width": "200"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "stuId",
      "label": "学号/教职工号",
      "width": "200"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "gender",
      "label": "性别"
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-58dedba9!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/xiaoyuan/GX/teacherManage.vue
// module id = 1034
// module chunks = 0